import React from 'react';
import { useNavigate } from 'react-router-dom';

import UserMenu from './UserMenu';

import { Flex } from '../UI/Flex';
import { Box } from 'src/components/UI/Box';

import ExitIcon from '../Icons/ExitIcon';

import { ReactComponent as Logo } from 'src/assets/images/logo.svg';
import { DoctorRoutesMenu } from './DoctorRoutesMenu';
import { Show } from '@chakra-ui/react';
import { Button } from '../UI/Button';
import TutorialIcon from '../Icons/TutorialIcon';
import Typography from '../Typography';
import CallCenterIcon from '../Icons/CallCenterIcon';
import { useIsMobile } from 'src/helpers/useIsMobile';
import { AssistantRoutesMenu } from './AssistantRoutesMenu';
import { usePrescriberContext, USER_GROUPS } from 'src/providers/PrescriberProvider';
import { trackSideMenuTutorialsClick, trackSideMenuHelpClick } from 'src/services/tracking/events';

interface SidebarProps {
  onClose?(): void;
}

export const SIDE_BAR_WIDTH = '190px';

export function Sidebar(props: SidebarProps) {
  const { userGroup, prescriberId } = usePrescriberContext();

  const isMobile = useIsMobile();

  const navigate = useNavigate();

  const handleNavigateToTutorials = () => {
    trackSideMenuTutorialsClick(prescriberId || undefined);
    navigate('/inicio/tutorial');
  };

  const handleNavigateToHelp = () => {
    trackSideMenuHelpClick(prescriberId || undefined);
    navigate('/inicio/ajuda');
  };

  return (
    <Box
      bg={'surface'}
      w={SIDE_BAR_WIDTH}
      h={'full'}
      p={'20px'}
      borderRadius={'0px 20px 20px 0px'}
      position={'fixed'}
      overflow={'auto'}
    >
      <Show below="sm">
        <Flex mb={'80px'} alignItems={'center'} justifyContent={'space-between'} pt={'10px'} h={'50px'}>
          <UserMenu />
          <ExitIcon variantColor="secondary" onClick={props.onClose} />
        </Flex>
      </Show>

      <Flex justifyContent={'center'}>
        <Logo fill={'#3D0E6B'} width={'100%'} height={'25px'} />
      </Flex>

      <Flex
        h={'calc(100% - 55px)'}
        w={'100%'}
        flexDirection={'column'}
        mt={'30px'}
        justifyContent={'space-between'}
        gap={'10px'}
      >
        {userGroup === USER_GROUPS.prescriber ? <DoctorRoutesMenu /> : <AssistantRoutesMenu />}

        <Box position={'unset'} bottom={'20px'} left={'20px'} w={'100%'}>
          <Button
            w={'100%'}
            borderRadius={'30px'}
            px={'20px'}
            bg={'surface'}
            variant={isMobile ? 'ghost' : 'outline-secondary'}
            minH={{ base: '60px', sm: '62px' }}
            boxShadow={'none'}
            display={'flex'}
            justifyContent={'flex-start'}
            onClick={handleNavigateToTutorials}
            gap={'10px'}
            mb={'5px'}
          >
            <TutorialIcon variantColor={'support.blue'} width={20} />

            <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'left'} weight="bold">
              Tutoriais
            </Typography>
          </Button>
          <Button
            w={'100%'}
            borderRadius={'30px'}
            px={'20px'}
            bg={'surface'}
            variant={isMobile ? 'ghost' : 'outline-secondary'}
            minH={'62px'}
            boxShadow={'none'}
            display={'flex'}
            justifyContent={'flex-start'}
            onClick={handleNavigateToHelp}
            gap={'10px'}
          >
            <CallCenterIcon variantColor={'support.blue'} width={20} />

            <Typography whiteSpace={'pre-wrap'} model={'body'} size={'normal'} textAlign={'left'} weight="bold">
              Precisando de ajuda?
            </Typography>
          </Button>
        </Box>
      </Flex>
    </Box>
  );
}
